export default {
  deliveryMethodHeader: "Setup Delivery Method",
  deliveryMethodContent:
    "Choose your delivery method to deliver orders to your customers .",
  restaurantHeader: "Restaurant delivering",
  restaurantContent: "Restaurant will send the order to the customer",
  koinzHeader: "Koinz delivering",
  koinzContent: "Koinz courier will send the order to the customer",
};
